//
//
//
//
//
//

import { LOAN_TYPES } from './const'

export default {
    data () {
        return {
            types: [
                LOAN_TYPES.BUSINESS,
                LOAN_TYPES.PUBLIC_FUND,
                LOAN_TYPES.COMPOSE
            ].map((item) => {
                return {
                    key: item,
                    name: item
                }
            })
        }
    },
    methods: {
        changeType (e) {
            const { name } = e.detail
            this.$emit('onChange', name)
        }
    },
    props: ['type']
}
